import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import SwalTopEnd from "../../../utils/swal_top_end";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import ExportExcel from "../../../utils/ExcelExport";

const url = BaseUrl();
function HomeStatsPage(){
  const [vendeurEvdPos,setVendeurEvdPos] = useState([]);
  const [periode1,setPeriode1] = useState('date');
  const [dateChoose1,setDateChoose1] = useState(null);
  const [loading1,setLoading1] = useState(false);
  const [topLimit1,setTopLimit1] = useState(100);
  
  const [venteEvdSecteur,setVenteEvdSecteur] = useState([]);
  const [periode2,setPeriode2] = useState('date');
  const [dateChoose2,setDateChoose2] = useState(null);
  const [loading2,setLoading2] = useState(false);

  const [approCcl,setApproCcl] = useState([]);
  const [periode3,setPeriode3] = useState('');
  const [loading3,setLoading3] = useState(false);

  const [approSecteur,setApproSecteur] = useState([]);
  const [periode4,setPeriode4] = useState('');
  const [loading4,setLoading4] = useState(false);

  const [periode5,setPeriode5] = useState('date');
  const [dateChoose5,setDateChoose5] = useState(null);
  const [loading5,setLoading5] = useState(false);
  const [topLimit,setTopLimit] = useState(100);

  const [loading6,setLoading6] = useState(false);
  const [dateChoose6,setDateChoose6] = useState(null);
  const [periode6,setPeriode6] = useState('date');

  const [loading7,setLoading7] = useState(false);
  const [dateChoose7,setDateChoose7] = useState(null);
  const [periode7,setPeriode7] = useState('date');

  const [recapCommercialEvd,setRecapCommercialEvd] = useState([]);
  const [recapCommercialMomo,setRecapCommercialMomo] = useState([]);

  const {user,role, permissions} = useContext(UserContext);
  const navigate = useNavigate();
  useEffect(()=>{
    // if(user && permissions && !can(permissions,'VENTE MOMO COMMERCIAUX')){
    //     navigate('/page-no-found');
    // }
  },[user]);

  const DownloadVentePosEvdFile= ()=>{
    // e.preventDefault();    
    // console.log(periode1);
    if(dateChoose1 == null && periode1 == "date"){
      SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
      return;
    }
    setLoading1(true);
    try {
        axios.post(url.base+'/export-evd-by-pos',{periode:periode1,date_choose:dateChoose1,top:topLimit1},{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
                
            },
            responseType:'blob',
            // credentials:'include'
        }).then((response)=>{
          setLoading1(false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'top_vendeurs_pos_evd.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }).catch((error)=>{
          setLoading1(false);
            console.log(error);
        })
    } catch (error) {
      setLoading1(false);
        console.log(error);  
    }
}


const DownloadFileSecteurEvd= ()=>{
  // e.preventDefault();    
  // console.log(periode1);
  if(dateChoose2 == null && periode2 == "date"){
    SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
    return;
  }
  setLoading2(true);
  try {
      axios.post(url.base+'/export-evd-by-secteurs',{periode:periode2,date_choose:dateChoose2},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
          // credentials:'include'
      }).then((response)=>{
        setLoading2(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ventes_evd_secteurs.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading2(false);
          console.log(error);
      })
  } catch (error) {
    setLoading2(false);
      console.log(error);  
  }
}


const DownloadFileApproCommercial= ()=>{
  // e.preventDefault();    
  // console.log(periode1);
  setLoading3(true);
  try {
      axios.post(url.base+'/export-appro-commercial',{periode:periode3},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
          // credentials:'include'
      }).then((response)=>{
        setLoading3(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'approvisionnement_commercial_stats.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading3(false);
          console.log(error);
      })
  } catch (error) {
    setLoading3(false);
      console.log(error);  
  }
}

const DownloadFileApproCommercialSecteurs= ()=>{
  // e.preventDefault();    
  // console.log(periode1);
  setLoading4(true);
  try {
      axios.post(url.base+'/export-appro-secteurs-commercial',{periode:periode3},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
          // credentials:'include'
      }).then((response)=>{
        setLoading4(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'appros_secteurs_commercial_stats.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading4(false);
          console.log(error);
      })
  } catch (error) {
    setLoading4(false);
      console.log(error);  
  }
}

const DownloadVentePosMomoFile= ()=>{
  // e.preventDefault();    
  // console.log(periode1);
  if(dateChoose5 == null && periode5 == "date"){
    SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
    return;
  }
  setLoading5(true);
  try {
      axios.post(url.base+'/export-momo-by-pos',{periode:periode5,date_choose:dateChoose5,top:topLimit},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
          // credentials:'include'
      }).then((response)=>{
        setLoading5(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'top_vendeurs_pos_momo.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading5(false);
          console.log(error);
      })
  } catch (error) {
    setLoading5(false);
      console.log(error);  
  }
}

const DownloadRecapVenteDesCommerciaux= ()=>{
  if(dateChoose6 == null && periode6 == "date"){
    SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
    return;
  }
  setLoading6(true);
  try {
      axios.post(url.base+'/recap_vente_des_commerciaux_evd',{periode:periode6,date_choose:dateChoose6},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
      }).then((response)=>{
        setLoading6(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'recap_des_ventes_evd_commerciaux.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading6(false);
          console.log(error);
      })
  } catch (error) {
    setLoading6(false);
      console.log(error);  
  }
}

const DownloadRecapVenteMomoDesCommerciaux= ()=>{
  if(dateChoose7 == null && periode7 == "date"){
    SwalTopEnd({icon:'error',title:'Désolé, veuillez choisir la date.'});
    return;
  }
  setLoading7(true);
  try {
      axios.post(url.base+'/recap_vente_momo_des_commerciaux',{periode:periode7,date_choose:dateChoose7},{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`,
              
          },
          responseType:'blob',
      }).then((response)=>{
        setLoading7(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'recap_des_ventes_momo_commerciaux.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((error)=>{
        setLoading7(false);
          console.log(error);
      })
  } catch (error) {
    setLoading7(false);
      console.log(error);  
  }
}




    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Gestion des rapports</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Page statistique</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              {/* <div class="header-left">
                <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-distributeur"> Ajouter un distributeur</Link>
                <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button>
              </div> */}
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">EVD & MOMO</h4>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>DESIGNATION</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="text-center">ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>                          
                                <td className="fw-bold">Vente EVD des commerciaux</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                    <Link class="btn btn-primary" to="/evd-commerciaux"> Acceder </Link>
                                </td>
                          </tr> */}

                          <tr>                          
                                <td className="fw-bold">Vente MOMO des commerciaux</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                    <Link class="btn btn-primary" to="/momo-commerciaux"> Acceder </Link>
                                </td>
                          </tr>

                           {/* <tr>
                            
                                <td className="fw-bold">Vente EVD des POS</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/evd-pos"> Acceder </Link>
                                </td>

                          </tr> */}

                          {/* <tr>
                            
                            <td className="fw-bold">Top vendeurs EVD par POS</td>
                            <td >
                            <select className="m-2 form-control text-dark border" onChange={(e)=>{setPeriode1(e.target.value);setDateChoose1(null);}}>
                                <option value="date">Choisir une date</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="annee">Cette année</option>
                            </select>
                            </td>
                            <td>
                            {periode1 == "date" &&
                              <>
                              <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose1(e.target.value)}/>
                              </>
                            }
                            </td>
                            <td>
                              <select className="mx-2 form-control text-dark border" onChange={(e)=>{setTopLimit1(e.target.value);}}>
                                  <option value="100">TOP 100</option>
                                  <option value="500">TOP 500</option>
                                  <option value="1000">TOP 1000</option>
                              </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class={!loading1 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadVentePosEvdFile()} disabled={user && permissions && !can(permissions,'TOP VENDEURS EVD') ? "disabled" : ""}> {!loading1 ? "Télécharger" :<span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                            </td>

                          </tr>  */}
{/* 
                          <tr>
                            
                            <td className="fw-bold">Top 10 des meilleurs vendeurs par commercial</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class="btn btn-success" > Télécharger </button>
                            </td>

                          </tr> */}
                          {/* <tr>
                            
                            <td className="fw-bold">Vente EVD par secteur</td>
                            <td>
                            <select className="mx-2 form-control text-dark border" onChange={(e)=>{setPeriode2(e.target.value);setDateChoose2(null);}}>
                                <option value="date">Choisir une date</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="annee">Cette année</option>
                            </select>
                            </td>
                            <td>
                            {periode2 == "date" &&
                              <>
                              <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose2(e.target.value)}/>
                              </>
                            }
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                                <button class={!loading2 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadFileSecteurEvd()} disabled={user && permissions && !can(permissions,'VENTE EVD PAR SECTEUR') ? "disabled" : ""}> {!loading2 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                            </td>

                          </tr> */}

                          <tr>
                            
                            <td className="fw-bold">Top vendeurs MOMO par POS</td>
                            <td>
                            <select className="mx-2 form-control text-dark border" onChange={(e)=>{setPeriode5(e.target.value);setDateChoose5(null);}}>
                            <option value="date">Choisir une date</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="annee">Cette année</option>
                            </select>
                            </td>
                            <td>
                            {periode5 == "date" &&
                              <>
                              <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose5(e.target.value)}/>
                              </>
                            }
                            </td>
                            <td>
                            <select className="mx-2 form-control text-dark border" onChange={(e)=>{setTopLimit(e.target.value);}}>
                            <option value="100">TOP 100</option>
                                <option value="500">TOP 500</option>
                                <option value="1000">TOP 1000</option>
                            </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class={!loading5 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadVentePosMomoFile()} disabled={user && permissions && !can(permissions,'TOP VENDEURS MOMO') ? "disabled" : ""}> {!loading5 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                            </td>

                          </tr> 

                          <tr>                            
                                <td className="fw-bold">Performances EVD</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/performances-evd"> Acceder </Link>
                                </td>
                          </tr>

                          <tr>                            
                                <td className="fw-bold">Performances MOMO</td>
                                <td class="py-1"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <Link class="btn btn-primary" to="/performances-momo"> Acceder </Link>
                                </td>
                          </tr>

                          <tr>
                            
                                <td className="fw-bold">RECAPITULATIF DES VENTES EVD DES COMMERCIAUX</td>
                                <td >
                                  <select className="m-2 form-control text-dark border" onChange={(e)=>{setPeriode6(e.target.value);setDateChoose6(null);}}>
                                      <option value="date">Choisir une date</option>
                                      <option value="semaine">Cette semaine</option>
                                      <option value="mois">Ce mois</option>
                                      <option value="last_month">Le mois dernier</option>
                                      <option value="annee">Cette année</option>
                                  </select>
                                  </td>
                                  <td>
                                  {periode6 == "date" &&
                                    <>
                                    <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose6(e.target.value)}/>
                                    </>
                                }
                                  </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                  <button class={!loading6 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadRecapVenteDesCommerciaux()}> {!loading6 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                                </td>

                          </tr>

                          <tr>
                            
                                <td className="fw-bold">RECAPITULATIF DES VENTES CASHIN ET CASHOUT DES COMMERCIAUX</td>
                                {/* <td class="py-1"></td> */}
                                <td >
                                <select className="m-2 form-control text-dark border" onChange={(e)=>{setPeriode7(e.target.value);setDateChoose7(null);}}>
                                    <option value="date">Choisir une date</option>
                                    <option value="semaine">Cette semaine</option>
                                    <option value="mois">Ce mois</option>
                                    <option value="last_month">Le mois dernier</option>
                                    <option value="annee">Cette année</option>
                                </select>
                                </td>
                                <td>
                                {periode7 == "date" &&
                                  <>
                                    <input type="date" className="form-control m-2 " onChange={(e)=>setDateChoose7(e.target.value)}/>
                                  </>
                                }
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-center">
                                <button class={!loading7 ? "btn btn-success" : "btn btn-default disabled"} type="button" onClick={()=>DownloadRecapVenteMomoDesCommerciaux()}> {!loading7 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                                </td>

                          </tr>
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">APPROVISIONNEMENTS</h4>
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>DESIGNATION</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="text-center">ACTIONS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            
                            <td className="fw-bold">Distributeurs</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                                <Link class="btn btn-primary" to="/parametres/distributeurs"> Acceder </Link>
                            </td>

                          </tr> */}

                          <tr>
                            
                            <td className="fw-bold">Approvisionnement et visite des commerciaux</td>
                            <td>
                            <select className="mx-2 form-control text-dark border" onChange={(e)=>setPeriode3(e.target.value)}>
                                <option value="" selected>Selectionner une période</option>
                                <option value="jour">En ce jour</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="annee">Cette année</option>
                            </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class={!loading3 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadFileApproCommercial()} disabled={user && permissions && !can(permissions,'STAT APPROVISIONNEMENT COMMERCIAUX') ? "disabled" : ""}> {!loading3 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                            </td>

                          </tr>

                          {/* <tr>
                            
                            <td className="fw-bold">Rôles</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <Link class="btn btn-primary" to="/parametres/roles"> Acceder </Link>
                            </td>

                          </tr>

                          <tr>
                            
                            <td className="fw-bold">Permissions</td>
                            <td class="py-1"></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <Link class="btn btn-primary" to="/parametres/permissions"> Acceder </Link>
                            </td>

                          </tr> */}

                          <tr>
                            
                            <td className="fw-bold">Approvisionnement par secteur </td>
                            <td>
                            <select className="mx-2 form-control text-dark border" onChange={(e)=>setPeriode4(e.target.value)}>
                                <option value="" selected>Selectionner une période</option>
                                <option value="jour">En ce jour</option>
                                <option value="semaine">Cette semaine</option>
                                <option value="mois">Ce mois</option>
                                <option value="last_month">Le mois dernier</option>
                                <option value="annee">Cette année</option>
                            </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-center">
                            <button class={!loading4 ? "btn btn-success" : "btn btn-default disabled"} onClick={()=>DownloadFileApproCommercialSecteurs()} disabled={user && permissions && !can(permissions,'STAT APPROVISIONNEMENT COMMERCIAUX') ? "disabled" : ""}> {!loading4 ? "Télécharger" : <span><i class="fa-solid fa-spinner fa-spin"></i> Téléchargement en cours</span>}  </button>
                            </td>

                          </tr>
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div class="modal fade" id="exampleModalFiltre"  tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-md" role="document">
                        <form class="modal-content" onSubmit={submitChangePass}>
                            <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalCenterTitle">Modifier votre mot de passe</h5>
                            <button type="button" class="btn-close" onClick={()=>window.$("#exampleModalFiltre").modal('hide')}>
                            </button>
                            </div>
                            <div class="modal-body">
                                <div className="row">
                                    <div class="mb-3 col-md-12">
                                    <label className="form-label">Ancien mot de passe</label>
                                    <input type="password" className="form-control" name="oldPass" onChange={handleChangePass} value={changePass.oldPass}/>
                                        {errorPass !=='' && <span className="text-danger">{errorPass}</span>}
                                    </div>  
                                    <div class="mb-3 col-md-12">
                                        <label className="form-label">Nouveau mot de passe</label>
                                        
                                        <div className="input-group">
                                            <input className="form-control fakepassword" type="password" id="psw-input" name="newPass"  onChange={handleChangePass} value={changePass.newPass} />
                                          
                                        </div>
                            
                                    </div> 
                                    <div class="mb-3 col-md-12">
                                    <label className="form-label">Confirmer votre mot de passe</label>
                                    <input type="password" className="form-control" placeholder="" name="cfmPass" onChange={handleChangePass} value={changePass.cfmPass}/>
                                    {errorPassEg !=='' &&  <span className="text-danger">{errorPassEg}</span>}
                            
                                    </div> 
                                </div> 
                                    
                            </div>
                            <div class="modal-footer">
                            {!loading && <button type="submit" class="btn btn-primary" >Enregistrer la modification</button>}
                                {loading && 
                                <button type="button" class= "btn btn-primary disabled form-control">Chargement en cours  <div class="text-center">
                                  <div class="spinner-border p-2" role="status">
                                  </div>
                                </div>
                                </button> 
                                }
                            </div>
                        </form>
                    </div>
            </div> */}
            </ContentPage>
        </>
    )
}
export default HomeStatsPage;